import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, size, space } from '../../theme/tokens';
import { EntityImage } from '../EntityImage';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: ${space['space-1200']};
  padding: 0 ${space['space-600']} ${space['space-300']};
  background: ${semantic.bg.canvas};
  border-bottom: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  box-sizing: border-box;

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: 0 ${space['space-2000']} ${space['space-600']};
  }
`;

export const LogoImg = styled(EntityImage)`
  max-height: ${primitives.size['size-1400']};
  max-width: 100%;
  object-fit: contain;
`;

export const NameText = styled.span`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  letter-spacing: ${primitives.typography.tracking.normal};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['2xl']};
  }
`;
